/* ==========================================================================
   GURBET — checkout consent gate

   Stops a checkout that has not agreed to the shipping policy and terms. Both
   checkout controls on this store are plain <a href="/checkout"> links rather than
   a form's submit button, so there is nothing to set `disabled` on — the gate has
   to intercept the click and only let the browser follow the link once the box is
   ticked.

   One file covers both, because there are two ways to reach checkout:
     - the cart drawer (sections/cart-drawer.liquid), on every template
     - the cart page  (sections/cart-section.liquid), at /cart, reachable by direct
       URL whether or not the drawer is enabled
   Gating one and not the other would be the same as gating neither.
   ========================================================================== */
(function () {
  'use strict';

  var MESSAGE = 'Please agree to the shipping policy and terms to continue.';

  /* Delegated from the document rather than bound per button. The drawer's markup
     is present from first paint, but binding directly would still tie this file to
     the drawer's load order — and delegation costs nothing here. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.btn-checkout');
    if (!btn) return;

    var consent = findConsentFor(btn);
    if (!consent) return;                     /* no gate rendered here — let it through */

    var box = consent.querySelector('[data-gb-consent-box]');
    if (!box || box.checked) return;          /* agreed: behave like an ordinary link */

    e.preventDefault();
    show(consent, box);
  }, true);

  /* Clearing on change rather than on submit, so the error goes the moment the
     shopper does the thing it asked for. */
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-gb-consent-box]');
    if (!box || !box.checked) return;
    var consent = box.closest('[data-gb-consent]');
    if (consent) hide(consent);
  });

  /* The consent block that belongs to THIS button: nearest one inside the same
     cart footer. Falling back to "the only one on the page" covers a layout that
     puts them in different containers, and refusing to guess when there are several
     is deliberate — silently gating the wrong checkout is worse than not gating. */
  function findConsentFor(btn) {
    var scope = btn.closest('#cart-drawer-footer, .cart-page-footer, #cart-drawer, .cart-page');
    if (scope) {
      var local = scope.querySelector('[data-gb-consent]');
      if (local) return local;
    }
    var all = document.querySelectorAll('[data-gb-consent]');
    return all.length === 1 ? all[0] : null;
  }

  function show(consent, box) {
    var err = consent.querySelector('[data-gb-consent-err]');
    if (err) { err.textContent = MESSAGE; err.hidden = false; }
    consent.classList.remove('is-invalid');
    /* Restart the nudge if it is already running: re-adding a class in the same
       frame does not replay a CSS animation, reading offsetWidth between the two
       forces the style recalculation that does. */
    void consent.offsetWidth;
    consent.classList.add('is-invalid');
    try { box.focus({ preventScroll: false }); } catch (e) { box.focus(); }
  }

  function hide(consent) {
    var err = consent.querySelector('[data-gb-consent-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    consent.classList.remove('is-invalid');
  }
})();
